import {
  Directive,
  EventEmitter,
  HostListener,
  Output,
  Input,
  Renderer2,
  ElementRef,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

import { defaultSizeLimit } from './file-upload-const';
import { FileValidationService } from './file-validation.service';

@Directive({
  selector: '[appFileUploadDrop]',
})
export class FileUploadDropDirective implements OnChanges {
  @Input({ required: true }) isMultiple: boolean;
  @Input({ required: true }) accept: string;
  @Input() files: any[] = [];
  @Input() sizeLimit = defaultSizeLimit;
  @Input() imageSizeLimit = defaultSizeLimit;

  @Output() filesDrop = new EventEmitter<File[]>();

  readonly dragZoneActiveClass = 'drag-zone-active';
  readonly dragZoneMultipleError = 'drag-zone-multiple-error';

  constructor(
    private renderer: Renderer2,
    private hostElement: ElementRef,
    private fileValidationService: FileValidationService
  ) {}

  @HostListener('drop', ['$event']) ondrop($event: DragEvent): void {
    $event.preventDefault();
    $event.stopImmediatePropagation();

    this.removeClass(this.dragZoneActiveClass);
    this.removeClass(this.dragZoneMultipleError);

    if (this.canUploadMoreFiles($event.dataTransfer.files)) {
      this.onFilesDropped($event.dataTransfer.files);
    }
  }

  @HostListener('dragover', ['$event'])
  onDragOver($event: DragEvent): void {
    $event.preventDefault();
    $event.stopImmediatePropagation();

    this.addClass(this.dragZoneActiveClass);

    if (!this.canUploadMoreFiles($event.dataTransfer.items)) {
      this.addClass(this.dragZoneMultipleError);
    }
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave($event: DragEvent): void {
    $event.preventDefault();
    $event.stopImmediatePropagation();

    this.removeClass(this.dragZoneActiveClass);
    this.removeClass(this.dragZoneMultipleError);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.files) {
      this.files = changes.files.currentValue || [];
    }
  }

  canUploadMoreFiles(items: FileList | DataTransferItemList): boolean {
    // the sum of items to add and already added items must be equal or
    // lower then 1 if multiple uploads are not allowed
    return (
      this.isMultiple || (items || []).length + (this.files || []).length <= 1
    );
  }

  onFilesDropped(fileList: FileList): void {
    const files: File[] = Array.from(fileList || []);

    const validFiles = this.fileValidationService.validateFiles(
      files,
      this.accept,
      this.sizeLimit,
      this.imageSizeLimit
    );

    this.filesDrop.emit(validFiles);
  }

  addClass(cssClass: string): void {
    this.renderer.addClass(this.hostElement.nativeElement, cssClass);
  }

  removeClass(cssClass: string): void {
    this.renderer.removeClass(this.hostElement.nativeElement, cssClass);
  }
}
